module.exports = __webpack_public_path__ + "img/save2-fill.c7390e0c.svg";